import { render } from "./PageIndicator.vue?vue&type=template&id=002fd6bc&scoped=true"
import script from "./PageIndicator.vue?vue&type=script&lang=js"
export * from "./PageIndicator.vue?vue&type=script&lang=js"

import "./PageIndicator.vue?vue&type=style&index=0&id=002fd6bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-002fd6bc"]])

export default __exports__